<template>
  <div>
    <el-dialog
      :title="submitMode + ' ' + formTitle"
      :visible.sync="dialogFormVisible"
      :before-close="closeEventDialog"
      @open="OnOpeningEventForm"
    >
      <el-form :model="form" ref="form" label-position="top">
        <el-row>
          <el-col :span="13">
            <el-form-item
              label="Evento"
              prop="title"
              :rules="[
                {
                  required: true,
                  message: 'El titulo del evento es requerido',
                  trigger: 'blur'
                }
              ]"
            >
              <el-input
                v-model="form.title"
                :disabled="eventSelectedIsTask"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col class="text-center" :span="1">&nbsp;</el-col>
          <el-col class="text-left" :span="10">
            <el-form-item label="Frecuencia">
              <el-select
                v-model="form.frequency"
                placeholder="Frecuencia"
                :disabled="eventSelectedIsTask"
              >
                <el-option
                  v-for="item in frequencyOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="Descripción">
          <el-input
            type="textarea"
            v-model="form.description"
            :disabled="eventSelectedIsTask"
          ></el-input>
        </el-form-item>

        <!-- select employeeId -->
        <el-row>
          <el-col :span="6">
            <el-form-item
              label="Responsable"
              prop="employeeId"
              :rules="[
                {
                  required: true,
                  message: 'Debes seleccionar un responsable',
                  trigger: 'blur'
                }
              ]"
            >
              <el-select
                v-loading="loading"
                v-model="form.employeeId"
                filterable
                clearable
                size="mini"
                placeholder="Colaborador"
                @change="updateSelectedEmployee"
              >
                <el-option
                  v-for="item in employeesByDirection"
                  :key="item.EmployeeID"
                  :label="item.Name"
                  :value="item.EmployeeID"
                >
                  <template #default>
                    <div style="display: flex; align-items: center">
                      <el-avatar
                        v-if="item.Image"
                        style="margin-right: 8px"
                        size="small"
                        :src="item.Image"
                      ></el-avatar>
                      <el-avatar
                        v-else
                        style="margin-right: 8px"
                        size="small"
                        src="/static/images/avatar-2.jpg"
                      ></el-avatar>
                      <span style="color: #8492a6; font-size: 12px">{{
                        item.Name
                      }}</span>
                    </div>
                  </template>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="Tipo de Agenda" prop="agendaType">
              <el-select
                v-model="form.agendaType"
                placeholder="Tipo de Agenda"
                :disabled="eventSelectedIsTask"
              >
                <el-option
                  v-for="item in agendaTypeSelect"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="6">
            <el-form-item
              label="Tiempo Estimado"
              class="formItemTopPad"
              :rules="[
                {
                  required: true,
                  message: 'Debes asignar tiempo',
                  trigger: 'blur'
                },
                {
                  type: 'number',
                  min: 0.5,
                  message:
                    'El tiempo minimo debe ser igual o mayor a 0.5 horas',
                  trigger: 'blur'
                }
              ]"
              prop="Time"
            >
              <!-- <el-input-number
                size="large"
                v-model="form.Time"
                :min="0"
                :controls="false"
              ></el-input-number> -->
              <TimeSelector
                :timeToEdit="form.Time"
                :defaultTime="0"
                size="large"
                @TimeSelected="onTimeSelected"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="Minutos / Horas"
              class="formItemTopPad"
              prop="MinutesHours"
            >
              <MinuteOurSelectoForTasks
                size="large"
                :MinuteHour="form.minutesHours"
                FixedMinuteHour="h"
                :disabled="true"
                @MinuteHoureChanged="MinuteHoureChanged"
              />
            </el-form-item>
          </el-col>
          <el-alert
            v-if="
              (form.Time > 8 && form.minutesHours === 'h') ||
              (form.Time > 480 && form.minutesHours === 'm')
            "
            type="error"
            title="Error de tiempo estimado"
            description="El tiempo No puede ser mayor a 8 horas o su equivalente 480 minutos"
            show-icon
          ></el-alert>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item
              label="Fecha De Inicio de Actividad"
              prop="startDateMonth"
            >
              <el-col :span="13">
                <el-date-picker
                  type="datetime"
                  placeholder="Fecha Inicio"
                  v-model="form.startDateMonth"
                  style="width: 100%"
                ></el-date-picker>
              </el-col>
            </el-form-item>
          </el-col>

          <el-col :span="6" v-if="form.frequency != 6">
            <el-form-item label="Fecha De Fin de Actividad" prop="endDateMonth">
              <el-col :span="13">
                <el-date-picker
                  type="datetime"
                  placeholder="Fecha Fin"
                  v-model="form.endDateMonth"
                  style="width: 100%"
                ></el-date-picker>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col class="ml-15" :span="5">
            <el-form-item label="Completado">
              <el-switch
                v-model="form.completed"
                active-color="#368939"
                active-text="Si"
                inactive-color="#ff352e"
                inactive-text="No"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              label="Fijar en Reportede tareas"
              class="formItemTopPad"
              prop="fixed"
            >
              <el-checkbox
                size="medium"
                v-model="form.fixed"
                :checked="form.fixed"
                @change="onFixedChange"
                >Fija?
              </el-checkbox>
            </el-form-item>
          </el-col>
          <el-col class="ml-15" :span="3">
            <el-button
              type="primary"
              icon="el-icon-document"
              size="mini"
              v-on:click="openFile(null)"
              v-if="form.evidence"
              >Ver Evidencia</el-button
            >
          </el-col>
        </el-row>
        <el-upload
          v-if="form.completed && !form.evidence"
          ref="uploadFile"
          :drag="true"
          class="upload-demo"
          action="https://apicloud.magycorp.com:48028/api/gallery/uploadanyFile"
          :limit="1"
          list-type="text"
          :on-success="handleUploadOnSuccess"
          :on-change="handleChange"
          :on-remove="handleRemove"
          :on-exceed="handleExceed"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Suelta tu archivo aquí o <em>haz clic para cargar</em>
          </div>
        </el-upload>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeEventDialog" :disabled="disableBtn"
          >Cancelar</el-button
        >
        <el-button
          type="danger"
          :disabled="disableBtn"
          @click="openDeleteDialog"
          v-loading="loading"
          v-if="isDelete && userIsSupervisor"
          >Eliminar</el-button
        >
        <el-button
          type="primary"
          @click="submitEvent"
          v-loading="loading"
          :disabled="
            disableBtn ||
            (form.Time > 8 && form.minutesHours === 'h') ||
            (form.Time > 480 && form.minutesHours === 'm')
          "
          v-if="
            userIsSupervisor &&
            (rulesForDisablingSaveButton ? !rulesForDisablingSaveButton : true)
          "
          >Guardar</el-button
        >
      </span>
    </el-dialog>
    <!-- Event Delete Dialog -->
    <el-dialog
      title="Confirmación de eliminación"
      :visible.sync="deleteConfirmationVisible"
      width="30%"
    >
      <span>¿Está seguro/a de que desea eliminar este evento?</span>
      <br />
      <span>Esta acción no puede ser revertida</span>

      <br />
      <br />
      <br />

      <el-switch
        v-model="onlyEvent"
        active-color="#368939"
        active-text="Este solo Evento"
        inactive-color="#80ced6"
        inactive-text="Todos los relacionados"
      ></el-switch>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="deleteConfirmationVisible = false"
          :disabled="disableBtn"
          v-loading="loading"
          >Cancelar</el-button
        >
        <el-button
          type="danger"
          @click="handleDeleteEvent"
          :disabled="disableBtn"
          v-loading="loading"
          >Eliminar</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment-timezone";
import GetEmployeeMaintenance from "./SelectEmployeeMaintenance";
import MinuteOurSelectoForTasks from "@/components/cmi/ObjectivesReport/MinuteOurSelectoForTasks";
import TimeSelector from "@/components/cmi/ObjectivesReport/TimeSelector";

export default {
  name: "CalendarMaintenanceEventForm",
  components: {
    MinuteOurSelectoForTasks,
    TimeSelector
  },
  props: {
    form: {
      type: Object,
      default: function () {
        return {
          title: "",
          description: "",
          allDay: false,
          startDate: "",
          startTime: "",
          endDate: "",
          endTime: "",
          agendaType: 23,
          frequency: 6,
          color: "#F22727",
          completed: false,
          evidence: "",
          employeeId: "",
          startDateMonth: "",
          endDateMonth: "",
          Time: 0,
          minutesHours: "h",
          fixed: true
        };
      }
    },
    submitMode: {
      type: String
    },
    dialogFormVisible: {
      type: Boolean
    },
    rulesForDisablingSaveButton: {
      type: Boolean,
      default: false
    },
    rulesForDisablingDelete: {
      type: Boolean,
      default: false
    },
    eventSelectedIsTask: {
      type: Boolean,
      default: false
    },
    userIsSupervisor: {
      type: Boolean,
      default: false
    },
    currentlyChosenAgenda: {
      type: Object,
      default: function () {
        return {};
      }
    },
    userId: {
      type: Number,
      default: function () {
        return this.$store.state.user.user.UserID;
      }
    },
    currentChosenCalendarID: {
      type: Number
    },
    prospect: {
      type: String
    },
    contact: {
      type: String
    }
  },
  data() {
    return {
      employeesByDirection: [],
      agendaTypeSelect: [
        {
          value: 23,
          label: "Generico"
        }
      ],
      agendaTypeGeneric: [
        {
          value: 23,
          label: "Generico"
        }
      ],
      agendaTypeOptionsRRHH: [
        {
          value: 15,
          label: "Plantas"
        },
        {
          value: 16,
          label: "Limpieza Oficinas"
        },
        {
          value: 17,
          label: "Limpieza Techos"
        },
        {
          value: 18,
          label: "Pintura"
        },
        {
          value: 19,
          label: "Planta Electrica"
        },
        {
          value: 20,
          label: "Aire Acondicionado"
        },
        {
          value: 21,
          label: "Puertas"
        }
      ],
      agendaTypeOptionsOPR: [
        {
          value: 22,
          label: "Mantenimiento de vehiculo"
        }
      ],
      agendaTypeOptions: [
        {
          value: 0,
          label: "PC"
        },
        {
          value: 1,
          label: "Servidores"
        },
        {
          value: 2,
          label: "Switch"
        },
        {
          value: 3,
          label: "Laptop"
        },
        {
          value: 4,
          label: "Wifi"
        },
        {
          value: 5,
          label: "Velocidad de Internet"
        },
        {
          value: 6,
          label: "Antivirus"
        },
        {
          value: 7,
          label: "Backup Bade de Datos"
        },
        {
          value: 8,
          label: "Aire Data Center"
        },
        {
          value: 9,
          label: "Planta Data Center"
        },
        {
          value: 10,
          label: "Ups Data Center"
        },
        {
          value: 11,
          label: "Pruebas de Internet"
        },
        {
          value: 12,
          label: "Pruebas de Integridad de Datos de Clientes"
        },
        {
          value: 14,
          label: "Vehículos"
        }
      ],
      frequencyOptions: [
        {
          value: 0,
          label: "Diaria"
        },
        {
          value: 1,
          label: "Semanal"
        },
        {
          value: 2,
          label: "Mensual"
        },
        {
          value: 3,
          label: "Trimestral"
        },
        {
          value: 4,
          label: "Semestral"
        },
        {
          value: 5,
          label: "Anual"
        },
        {
          value: 6,
          label: "Sin Frecuencia"
        }
      ],
      submitModeOptions: {
        Add: "Agregar",
        Edit: "Editar"
      },
      deleteConfirmationVisible: false,
      loading: false,
      eventDates: [],
      fileList: [],
      onlyEvent: false,
      disableBtn: false
    };
  },
  async created() {
    await GetEmployeeMaintenance(this);
  },

  mounted() {
    this.changeOptions();
  },
  computed: {
    formTitle() {
      if (this.currentlyChosenAgenda.event) {
        if (this.currentlyChosenAgenda.event.extendedProps.isTask) {
          return "Tarea";
        } else {
          return "Evento";
        }
      } else {
        return "Evento";
      }
    },
    eventResponsibleEmployeeId() {
      const originalResponsibleId =
        this.currentlyChosenAgenda &&
        this.currentlyChosenAgenda.event &&
        this.currentlyChosenAgenda.event.extendedProps
          ? this.currentlyChosenAgenda.event.extendedProps.employeeId
          : null;

      return Number(
        originalResponsibleId !== null && originalResponsibleId !== undefined
          ? originalResponsibleId
          : this.form.employeeId
      );
    },
    isDelete() {
      let isEdit = this.submitMode === this.submitModeOptions.Edit;
      const isResponsible =
        Number(this.currentUser.EmployeeId) === this.eventResponsibleEmployeeId;

      return (
        (isEdit && !isResponsible) ||
        (isEdit && this.currentUser.PositionID == 16) || //CEO
        (isEdit && this.currentUser.PositionID == 123) || //SUB GERENTE DE TECNOLOGIA
        (isEdit && this.currentUser.PositionID == 82) || // GERENTE DE OPERACIONES Y PROYECTOS
        (isEdit && this.currentUser.PositionID == 129) //GERENTE DE ADMINISTRACIÓN , FINANZAS Y RECURSOS HUMANOS
      );
    }
    // IsMinuteHour() {
    //   let minuteHours;
    //   if (this.form.minutesHours === "m") {
    //     minuteHours = 480;
    //   } else {
    //     minuteHours = 8;
    //   }
    //   return minuteHours;
    // }
  },
  methods: {
    ...mapActions("calendarMaintenance", [
      "create",
      "update",
      "updateTaskInApi",
      "delete"
    ]),

    changeOptions() {
      if (this.currentUser.DireccionID == 45) {
        this.agendaTypeSelect = this.agendaTypeOptionsRRHH;
      }
      if (this.currentUser.DireccionID == 28) {
        this.agendaTypeSelect = [
          ...this.agendaTypeOptionsRRHH,
          ...this.agendaTypeOptions,
          ...this.agendaTypeOptionsOPR
        ];
        this.currentUser.PositionID;
      }
      if (this.currentUser.DireccionID == 49) {
        this.agendaTypeSelect = this.agendaTypeOptionsOPR;
      } else {
        this.agendaTypeSelect = this.agendaTypeGeneric;
      }
    },

    submitEvent() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // this.$emit("submit-event", this.form);

          if (this.submitMode === this.submitModeOptions.Add) {
            this.setEvent();
          } else if (this.submitMode === this.submitModeOptions.Edit) {
            if (this.form.completed && this.fileList.length == 0) {
              return this.$message.error(
                "Error al crear evento, debes de Subir Evidencia " +
                  "Para poder poner este evento como Completado"
              );
            }
            this.updateEvent();
          }
        }
      });
    },
    setEvent() {
      this.loading = true;
      this.disableBtn = true;
      //frecuencia Diaria
      var today = new Date();
      var currentYear = today.getFullYear();
      var startDate = new Date(currentYear, 0, 1); // 01 de enero del año
      // var endDate = new Date(currentYear, 11, 31);
      var currentDate = new Date(startDate);

      let start = moment(currentDate);

      if (this.form.startTime) {
        start.add(moment(this.form.startTime).format("HH"), "hours");
        start.add(moment(this.form.startTime).format("mm"), "minutes");
      }

      let event = {
        id: new Date().getTime(),
        title: this.form.title,
        description: this.form.description,
        start: start,
        allDay: this.form.allDay,
        agendaType: 23,
        frequency: this.form.frequency,
        employeeId: this.form.employeeId,
        startDateMonth: this.form.startDateMonth,
        endDateMonth: this.form.endDateMonth,
        Time: this.form.Time,
        minutesHours: "h", // this.form.minutesHours,
        fixed: this.form.fixed
      };

      if (this.form.color) event.color = this.form.color;
      let end = moment(currentDate);

      event.end = end.format();
      event.start = event.start.format();

      this.addEvent(event, currentDate, this.form.frequency);
    },
    updateEvent() {
      this.loading = true;

      let event = {
        id: new Date().getTime(),
        title: this.form.title,
        description: this.form.description,
        allDay: this.form.allDay,
        start: {},
        end: {},
        agendaType: 23,
        frequency: this.form.frequency,
        employeeId: this.form.employeeId,
        completed: this.form.completed,
        evidence: this.fileList.Url,
        startDateMonth: this.form.startDateMonth,
        endDateMonth: this.form.endDateMonth,
        Time: this.form.Time,
        minutesHours: "h", // this.form.minutesHours,
        fixed: this.form.fixed
      };

      if (this.form.color) event.color = this.form.color;

      let currentEndDate = new Date(
        this.currentlyChosenAgenda.event.extendedProps.endDate
      );
      let newEndDate = new Date(this.form.endDate);
      let newEndTime = new Date(this.form.endTime);

      let currentStartDate = new Date(
        this.currentlyChosenAgenda.event.extendedProps.startDate
      );
      let newStartDate = new Date(this.form.startDate);
      let newStartTime = new Date(this.form.startTime);

      // Change start hours and minutes

      if (
        currentStartDate.getHours() != newStartTime.getHours() ||
        currentStartDate.getMinutes() != newStartTime.getMinutes()
      ) {
        newStartDate.setHours(newStartTime.getHours());
        newStartDate.setMinutes(newStartTime.getMinutes());
      }

      let start = moment(newStartDate);
      event.start = start;

      // Change end hours and minutes
      if (
        currentEndDate.getHours() != newEndTime.getHours() ||
        currentEndDate.getMinutes() != newEndTime.getMinutes()
      ) {
        newEndDate.setHours(newEndTime.getHours());
        newEndDate.setMinutes(newEndTime.getMinutes());
      }

      let end = moment(newEndDate);
      event.end = end;

      event.end = event.end.format();
      event.start = event.start.format();

      this.update({
        CalendarioMaintenance_ID: this.currentChosenCalendarID,
        CreatedBy: this.currentlyChosenAgenda.event.extendedProps.createdBy,
        Content: event.description,
        DateTime: event.start,
        StarDate: event.start,
        EndDate: event.end,
        Title: event.title,
        Description: event.description,
        AllDay: event.allDay,
        Color: event.color,
        Id: this.currentlyChosenAgenda.event.id,
        AgendaType: 23,
        Frequency: event.frequency,
        EmployeeId: event.employeeId,
        Completed: event.completed,
        Evidence: event.evidence,
        TimeEstimated: event.Time,
        MinuteHour: "h", // event.minutesHours,
        IsFixed: event.fixed
      })
        .then(() => {
          this.loading = false;
          this.closeEventDialog();
          this.fileList = [];
          this.$message.success("Evento modificado exitosamente");
        })
        .catch(() => {
          this.loading = false;
          this.closeEventDialog();
          this.$message.error("Error al modificar evento");
        });
    },
    handleUploadOnSuccess(response) {
      this.fileList = response[0];
    },
    pdateSelectedEmployee(employee) {
      this.EmployeeId = employee;
    },
    handleChange() {
      this.filesUpload = 1;
    },
    handleRemove() {
      this.filesUpload = 0;
    },
    submitUpload() {
      this.$refs.uploadFile.submit();
    },
    handleExceed() {
      this.$message.warning(`El límite es 1, y ya haz seleccionado 1}`);
    },
    openFile(url = null) {
      if (url !== null) {
        window.open(url, "_blank");
      } else {
        window.open(this.form.evidence, "_blank");
      }
    },
    async handleDeleteEvent() {
      if (
        Number(this.currentUser.EmployeeId) === this.eventResponsibleEmployeeId
      ) {
        this.$message.error("El responsable del evento no puede eliminarlo");
        this.closeDeleteDialog();
        return;
      }

      try {
        this.loading = true;
        this.disableBtn = true;

        await this.delete({
          CalendarioMaintenance_ID: this.currentChosenCalendarID,
          AgendaID: this.currentlyChosenAgenda.event.id,
          UserId: this.userId,
          OnlyEvent: this.onlyEvent
        });
        this.$message.success("Evento eliminado exitosamente");
      } catch {
        this.$message.error("Error al eliminar evento");
      } finally {
        this.disableBtn = false;
        this.loading = false;
        this.closeEventDialog();
        this.closeDeleteDialog();
      }
    },
    closeEventDialog() {
      this.$emit("close-event-dialog");
      this.$refs["form"].resetFields();
      this.form.title = "";
      this.form.description = "";
      this.form.allDay = false;
      this.form.startDate = "";
      this.form.startTime = "";
      this.form.endDate = "";
      this.form.endTime = "";
      this.form.agendaType = 0;
      this.form.frequency = 6;
      this.form.employeeId = "";
      this.form.completed = 0;
      this.form.evidence = 0;
      this.form.color = "#F56C6C";
      this.form.Time = 0;
      this.form.minutesHours = "h";
      this.form.fixed = true;
    },
    openDeleteDialog() {
      this.deleteConfirmationVisible = true;
    },
    closeDeleteDialog() {
      this.deleteConfirmationVisible = false;
    },
    async addEvent(event, currentDate, frecuency) {
      let sDate =
        this.form.frequency != 6
          ? moment(currentDate)
          : moment(this.form.endDate);

      let eDate =
        this.form.frequency != 6
          ? moment(currentDate)
          : moment(this.form.endDate);
      const datos = {
        agenda: {
          CalendarioMaintenance_ID: this.currentChosenCalendarID,
          CreatedBy: this.$store.state.user.user.UserID,
          Content: event.description,
          DateTime: event.start,
          StarDate: sDate,
          EndDate: eDate,
          Title: event.title,
          Description: event.description,
          AllDay: event.allDay,
          Color: event.color,
          AgendaType: 23,
          Frequency: event.frequency,
          EmployeeId: event.employeeId,
          startDateMonth: event.startDateMonth,
          endDateMonth: event.endDateMonth,
          TimeEstimated: event.Time,
          MinuteHour: "h", // event.minutesHours,
          IsFixed: event.fixed
        },
        frecuency: frecuency // Valor de la frecuencia que deseas enviar
      };
      await this.create(datos)
        .then(() => {
          this.loading = false;
          this.disableBtn = false;
          this.closeEventDialog();
          this.$message.success("Evento creado exitosamente");
        })
        .catch(() => {
          this.loading = false;
          this.disableBtn = false;
          this.closeEventDialog();
          this.$message.error("Error al crear evento");
        });
    },
    updateSelectedEmployee(employeeId) {
      this.form.employeeId = employeeId;
    },
    MinuteHoureChanged(minuteHours) {
      this.form.minutesHours = minuteHours;
      // if (minuteHours === "h" && this.form.Time > 8) {
      //   this.form.Time = 8;
      // }
    },
    OnOpeningEventForm() {},
    onFixedChange(val) {
      this.form.fixed = val;
    },
    onTimeSelected(time) {
      this.form.Time = time;
    }
  },
  watch: {
    prospect(newProspect) {
      if (newProspect) {
        this.form.title = `Cita - ${newProspect}`;
        this.form.agendaType = 1; // Cita
      }
    }
  }
};
</script>
